// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"6e182a71","989":"21f69a9f","3658":"222f846a","5349":"da3eae7f","6243":"9d0939e9","8013":"b949142f","8529":"5ca93a1e"}[chunkId] + ".chunk.css";
};